export default __webpack_public_path__ + "static/media/Comment.17d1a9eb.svg";